import { render } from "./calender.vue?vue&type=template&id=08f626f3"
import script from "./calender.vue?vue&type=script&lang=js"
export * from "./calender.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__